import { render, staticRenderFns } from "./detail-attach.vue?vue&type=template&id=023b9acc&scoped=true"
import script from "./detail-attach.vue?vue&type=script&lang=js"
export * from "./detail-attach.vue?vue&type=script&lang=js"
import style0 from "./detail-attach.vue?vue&type=style&index=0&id=023b9acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b9acc",
  null
  
)

export default component.exports